export const AI_ASSISTANT_PATH = '/main/ai-assistant'

export const AI_DESKTOP_DOWNLOADS = {
    mac: 'https://ai-platform-api.senguo.cc/api/v1/desktop-releases/latest?platform=mac',
    windows: 'https://ai-platform-api.senguo.cc/api/v1/desktop-releases/latest?platform=windows',
}
